import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation } from "@tanstack/react-query";

import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { useCustomerValue } from "providers/CustomerContext";
import { formRender, initialValues, skuValidations } from "./sku-schema";
import { createSKU, uploadSKUImage } from "services/data.internal.service";
import SKUInfo from "./components/SKUInfo2";
import SKUImage from "./components/SKUImage";
import { useNavigate } from "react-router-dom";
import { useCustWhSettingQuery } from "hooks/useQueryHook";

function AddSKU2() {
  const { customerCode } = useCustomerValue();
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [newImages, setNewImages] = useState([]);
  const formValues = {
    ...initialValues,
    customerCode,
    movementType: "FAST",
    pickingRules: "FIFO-OLN",
    kitType: "SINGLE",
    currencyCode: "MYR",
  };
  const [auto, setAuto] = useState(false);

  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const createSKUMutation = useMutation(createSKU, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  useCustWhSettingQuery({
    customerCode,
    onSuccess: (data) => {
      if (data.data.data === undefined) {
        return;
      }
      const { autoCreation } = data.data.data;
      setAuto(autoCreation);
    },
    onError,
  });
  const uploadSKUImageMutation = useMutation(uploadSKUImage, { onError });
  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(skuValidations),
  });

  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
    reset,
  } = form;

  const infoProps = { control, setValue, errors, formRender };
  const createStatus = createSKUMutation.status === "loading";
  const onSubmit = (data) => {
    window.scrollTo(0, 0);
    createSKUMutation.mutate(data, {
      onSuccess: () => {
        let formData = new FormData();
        if (newImages.length > 0) {
          formData.append("skuCode", data.skuCode);
          formData.append("customerCode", data.customerCode);
          formData.append("defaultImage",newImages.filter(x=>x.default)[0].file.name)
          newImages.forEach((image) => {
            formData.append("productImage", image.file, image.file.name);
          });
          uploadSKUImageMutation.mutate(formData, {
            onSuccess: () => setNewImages([]),
          });
        }
        if (!auto) {
          navigate("/setup/sku/vendor-sku/add", { state: { customerCode:data.customerCode, skuCode: data.skuCode } });
        } else {
          navigate("/setup/sku/vendor-sku", { state: { customerCode:data.customerCode, skuCode: data.skuCode } });
          //reset();
        }
      },
    });
  };
  return (
    <Layout lg={12}>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <SKUInfo {...infoProps} />
        <SKUImage images={{ newImages, setNewImages }} />
        <SubmitButton label="submit" disabled={createStatus} url="/setup/sku" />
      </form>
    </Layout>
  );
}

export default AddSKU2;
